
import { mixins } from "vue-class-component";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ListWrapper extends Vue {}
